import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import Environment from '../../constants/Environment';
import EnvironmentVariables from '../../context/Environment/EnvironmentVariables';

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.get(`${process.env.PUBLIC_URL}/env.json`, (req, res, ctx) => {
    return res(
      ctx.json({
        ENVIRONMENT_NAME: Environment.TEST,
        AUTH_CLIENTID: 'EVERIFY-test',
        LOGIN_DOT_GOV_AUTH_CLIENTID: 'urn:gov:gsa:openidconnect.profiles:sp:sso:uscis:e-verify.test',
      } as EnvironmentVariables),
    );
  }),
];

export default handlers;
